// extracted by mini-css-extract-plugin
module.exports = {"inStock":"StockInformation_inStock__928e0","outOfStock":"StockInformation_outOfStock__b5e2a"};